export const leaderboardColumns = [
	{
		title: 'Rank',
		dataIndex: 'rank',
	},
	{
		title: 'Name',
		dataIndex: 'name',
	},
	{
		title: 'Email',
		dataIndex: 'email',
	},
	{
		title: 'Points',
		dataIndex: 'points',
	},
];
